import SESSION_RECORDING_EVENTS from "utils/session-recording-events"

export const HOTJAR_EVENTS = SESSION_RECORDING_EVENTS

export function sendHotjarEvent(eventName) {
  if (!eventName || typeof window.hj !== "function") return

  window.hj("event", eventName)
}
